export class Player {
     public firstNameAndLastName: string;

     constructor(firstNameAndLastName: string) {
        this.firstNameAndLastName = firstNameAndLastName;
    }
}